/**
 * API Client per gestione organizzazioni
 * Gestisce le chiamate CRUD per /api/v1/organisation
 */
class OrganisationAPI {
    constructor() {
        this.baseURL = '/api/v1/organisation';
    }

    // ============================================================================
    // METODI CRUD STANDARD
    // ============================================================================

    /**
     * GET /api/v1/organisation
     * Lista tutte le organizzazioni con schema DBMng
     */
    async getOrganisations() {
        try {
            const response = await fetch(this.baseURL);
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API getOrganisations:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch getOrganisations:', error);
            return { ok: false, message: error.message };
        }
    }

    /**
     * GET /api/v1/organisation/<id>
     * Dettaglio singola organizzazione
     */
    async getOrganisation(organisationId) {
        try {
            const response = await fetch(`${this.baseURL}/${organisationId}`);
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API getOrganisation:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch getOrganisation:', error);
            return { ok: false, message: error.message };
        }
    }

    /**
     * POST /api/v1/organisation
     * Crea nuova organizzazione
     */
    async createOrganisation(organisationData) {
        try {
            const response = await fetch(this.baseURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(organisationData)
            });
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API createOrganisation:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch createOrganisation:', error);
            return { ok: false, message: error.message };
        }
    }

    /**
     * PUT /api/v1/organisation/<id>
     * Aggiorna organizzazione esistente
     */
    async updateOrganisation(organisationId, organisationData) {
        try {
            const response = await fetch(`${this.baseURL}/${organisationId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(organisationData)
            });
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API updateOrganisation:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch updateOrganisation:', error);
            return { ok: false, message: error.message };
        }
    }

    /**
     * DELETE /api/v1/organisation/<id>
     * Elimina organizzazione
     */
    async deleteOrganisation(organisationId) {
        try {
            const response = await fetch(`${this.baseURL}/${organisationId}`, {
                method: 'DELETE'
            });
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API deleteOrganisation:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch deleteOrganisation:', error);
            return { ok: false, message: error.message };
        }
    }

    // ============================================================================
    // METODI SPECIALIZZATI
    // ============================================================================

    /**
     * GET /api/v1/organisation/stats
     * Statistiche organizzazioni per tipo
     */
    async getOrganisationStats() {
        try {
            const response = await fetch(`${this.baseURL}/stats`);
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API getOrganisationStats:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch getOrganisationStats:', error);
            return { ok: false, message: error.message };
        }
    }

    /**
     * GET /api/v1/organisation/search?q=term
     * Ricerca organizzazioni per nome o sigla
     */
    async searchOrganisations(searchTerm) {
        try {
            const queryParams = new URLSearchParams({
                q: searchTerm
            });
            
            const response = await fetch(`${this.baseURL}/search?${queryParams}`);
            const result = await response.json();
            
            if (!result.ok) {
                console.error('Errore API searchOrganisations:', result.message);
            }
            
            return result;
        } catch (error) {
            console.error('Errore fetch searchOrganisations:', error);
            return { ok: false, message: error.message };
        }
    }

    // ============================================================================
    // UTILITY METHODS
    // ============================================================================

    /**
     * Converte tipo numerico in label testuale
     */
    getTipoLabel(tipo) {
        switch(tipo) {
            case 0: return 'Privata';
            case 1: return 'Pubblica';
            default: return 'Sconosciuto';
        }
    }

    /**
     * Converte label testuale in valore numerico
     */
    getTipoValue(label) {
        switch(label.toLowerCase()) {
            case 'privata': return 0;
            case 'pubblica': return 1;
            default: return 0;
        }
    }

    /**
     * Validazione dati organizzazione lato client
     */
    validateOrganisationData(data) {
        const errors = [];

        // Validazione nome
        if (!data.nome || data.nome.trim().length === 0) {
            errors.push('Nome organizzazione richiesto');
        } else if (data.nome.length > 255) {
            errors.push('Nome troppo lungo (max 255 caratteri)');
        }

        // Validazione sigla
        if (!data.sigla || data.sigla.trim().length === 0) {
            errors.push('Sigla richiesta');
        } else if (data.sigla.length > 10) {
            errors.push('Sigla troppo lunga (max 10 caratteri)');
        }

        // Validazione tipo
        if (data.tipo === undefined || data.tipo === null) {
            errors.push('Tipo organizzazione richiesto');
        } else if (![0, 1].includes(parseInt(data.tipo))) {
            errors.push('Tipo organizzazione non valido');
        }

        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
}

// Export per uso in moduli
export default OrganisationAPI;